import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const RepositoriosController = {
  async ListRepositorios() {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + "repo_page/listrepos", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },

  async AddRepositorios(newRepoName, esterioValue, esterioOptionValue, newPromptName) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + "repo_page/", {
        reponame: newRepoName,
        esterio: esterioValue,
        esterio_side: esterioOptionValue,
        prompt: newPromptName
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating repo:", error);
      throw error;
    }
  },

  async PutRepositorios(Id, reponame, prompt) {
    try {
      const response = await axios.put(
        `${AppConfig.BACKEND_URL_REFATORADO}repo_page/${Id}`,
        { reponame, prompt },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating repo:", error);
      throw error;
    }
  },

  async DeleteRepositorios(Id) {
    try {
      const response = await axios.delete(
        `${AppConfig.BACKEND_URL_REFATORADO}repo_page/${Id}`, 
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting repo:", error);
      throw error;
    }
  },

  async  CountRepositoriosToReprocess(repoIds, startDate, endDate) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + "repo_page/listrepos_to_reprocess", {
        repo_id: repoIds
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      

      return response.data;
    } catch (error) {
      console.error("Erro:", error);
      throw error;
    }
  },

  async  ListRepositoriosToReprocess(repoIds, startDate, endDate) {
    try {

      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + "repo_page/listfichas_to_reprocess",  {

      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erro:", error);
      throw error;
    }
  },
  async  ListFichasToReprocess(repoIds, startDate, endDate) {
    try {
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + "repo_page/listfichas_to_reprocess", {
        repo_id: repoIds
      }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erroo:", error);
      throw error;
    }
  },
  async ReprocessRepos(repoIds, auditIds) {
    try {
      const response = await axios.post(
        `${AppConfig.BACKEND_URL_REFATORADO}repo_page/publisher/reprocess/repos`, 
 {
            repos_id: repoIds,
            audit_id: auditIds
          
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          }
        }
      );
      return response;
    } catch (error) {
      console.error("Error reprocessing repos:", error);
      throw error;
    }
  },
  async ReprocessReposJustTranscriptions(repo_id) {
    return axios
      .post(AppConfig.BACKEND_URL_REFATORADO + `repo_page/reprocess`,
        {
          repo_list: repo_id
        }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  },
};

export default RepositoriosController;